// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__iCNc8","boxTitle":"Qualiphy_boxTitle__3NPcP","box":"Qualiphy_box__1BDmF","toggleWrap":"Qualiphy_toggleWrap__3u7vM"};